__turbopack_context__.v({
  "actionButton": "styles-module__XjMJKq__actionButton",
  "actionButtons": "styles-module__XjMJKq__actionButtons",
  "anchor": "styles-module__XjMJKq__anchor",
  "anchor--active": "styles-module__XjMJKq__anchor--active" + " " + "styles-module__XjMJKq__anchor",
  "baseListItem": "styles-module__XjMJKq__baseListItem",
  "container": "styles-module__XjMJKq__container",
  "container--open": "styles-module__XjMJKq__container--open" + " " + "styles-module__XjMJKq__container",
  "header": "styles-module__XjMJKq__header",
  "list": "styles-module__XjMJKq__list",
  "popularTilesContainer": "styles-module__XjMJKq__popularTilesContainer",
});
